@let isSm = viewportSelectors.isSm | select;
<div class="flex flex-col items-center md:shrink-0">
  @if (isSm) {
    <div class="max-w-[18.75rem] relative overflow-hidden">
      <img ngSrc="/assets/registration/lookup-account-sm.png" fill priority alt="" class="relative flex w-full h-auto"/>
    </div>
  }
  <mat-card class="max-w-[25rem]">
    <mat-card-content class="flex flex-col gap-y-3">
      <div class="text-headline-large">Look Up Account</div>
      <div class="text-body-large mb-8">Enter your library card number and PIN to find your account and complete the
        online registration.
      </div>
      <mx-input-form-field fieldName="cardNumber" overrideLabel="Library Card Number" [formGroup]="lookupForm"
                           overrideBrowserAutocomplete="section-card username"/>
      <mx-input-form-field fieldName="pin" overrideLabel="PIN" [formGroup]="lookupForm" overrideBrowserAutocomplete="section-card password"/>
      <mx-filled-button label="Look Up Account" [enabled]="lookupForm.valid" (click)="onClickNext()" class="my-4"/>
      <div class="text-body-large self-center">
        Don’t have a library card? <a class="text-title-medium pl-2" pxNamedRouterLink="REGISTER">Sign up here</a>
      </div>
    </mat-card-content>
  </mat-card>
</div>

@if (!isSm) {
  <div class="relative overflow-hidden flex flex-row items-center w-[50%] max-w-[21rem] lg:max-w-[29.5rem] lg:h-[30rem]">
    <img ngSrc="/assets/registration/lookup-account.png" fill priority alt="" class="relative flex w-full h-auto"/>
  </div>
}
